var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'mixin', 'core', 'app-common/component/loader', 'app-common/component/notification', 'app-common/component/validation', 'app-common/component/region-control', 'app-common/component/binary-toggle', 'app-common/component/api-call', 'app-common/view/dialog', 'app-common/view/model-update', 'template/clientsettings/landing.htm', 'common/lib/forms/chosen.jquery', 'common/lib/forms/jquery.placeholder'], function($, _, mixin, core, loader, NotificationSupport, validation, regionControl, BinaryToggleView, apiCall, DialogView, ModelUpdateView, landingTemplate) {
  var ClientSettingsPage;
  return ClientSettingsPage = (function(_super) {

    __extends(ClientSettingsPage, _super);

    function ClientSettingsPage() {
      ClientSettingsPage.__super__.constructor.apply(this, arguments);
    }

    ClientSettingsPage.prototype.pageId = 'clientsettings';

    ClientSettingsPage.prototype.notificationSelector = function() {
      return '#dialog-window .notification-area';
    };

    ClientSettingsPage.prototype.initialize = function(options, params) {
      this.model = core.getModel('clientsettings');
      this.clientModel = core.getCurrentClient();
      this.clientId = core.getCurrentClientId();
      return this.render();
    };

    ClientSettingsPage.prototype.render = function() {
      var promise,
        _this = this;
      ClientSettingsPage.__super__.render.call(this, _.template(landingTemplate));
      this.$el.find("#email-for-receipts-toggle").append(new BinaryToggleView(null, "sendEmailNotificationForReceiptFiled", null, null, this.model.get("sendEmailNotificationForReceiptFiled")).render().el);
      this.$el.find("#email-for-comments-toggle").append(new BinaryToggleView(null, "sendEmailNotificationForComments", null, null, this.model.get("sendEmailNotificationForComments")).render().el);
      this.$el.find("#email-for-taxaccountants-toggle").append(new BinaryToggleView(null, "sendEmailNotificationToTaxAccountants", null, null, this.model.get("sendEmailNotificationToTaxAccountants")).render().el);
      promise = apiCall('person', "tax_accountant/client/" + this.clientId, 'GET');
      promise.done(function(taxAccountants) {
        var listItem, taxAccountant, _i, _len, _results;
        if (taxAccountants.length > 0) {
          _results = [];
          for (_i = 0, _len = taxAccountants.length; _i < _len; _i++) {
            taxAccountant = taxAccountants[_i];
            listItem = "<li>" + taxAccountant.fullName + ", " + taxAccountant.email + "</li>";
            _results.push(_this.$el.find("#emailNotificationTaxAccountantsList").append(listItem));
          }
          return _results;
        } else {
          return $('#sendEmailNotificationToTaxAccountants').text("Send my tax accountants an email when there's a new message");
        }
      });
      $('#clientsettings-form').submit(function(e) {
        e.preventDefault();
        return _this.saveSettings();
      });
      new ModelUpdateView({
        el: $('#clientsettings-form'),
        model: this.model
      });
      this.initSettingsValidation();
      return this.initNotifications();
    };

    ClientSettingsPage.prototype.initSettingsValidation = function() {
      return validation.init($('#clientsettings-form'));
    };

    ClientSettingsPage.prototype.initNotifications = function() {
      return this.setNotifications({
        save_success: {
          type: 'success',
          text: 'Your preferences were successfully updated.'
        },
        save_error: {
          type: 'error',
          text: 'Couldn\'t update preferences.'
        }
      });
    };

    ClientSettingsPage.prototype.saveSettings = function() {
      var promise,
        _this = this;
      if (!$('#clientsettings-form').valid()) {
        return;
      }
      loader.init({
        dialog: true
      });
      promise = this.model.save();
      promise.always(function() {
        return loader.hide();
      });
      promise.done(function() {
        return _this.showNotification('save_success');
      });
      return promise.fail(function() {
        return _this.showNotification('save_error');
      });
    };

    return ClientSettingsPage;

  })(mixin.of(DialogView, NotificationSupport));
});
